module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg5-62e38353bb20860cf5a83a2037da9006.jpg";